import {User} from 'src/openapi/models/User';
import {RootState} from 'src/store/store';

export const getUsersInfo = (state: RootState): Record<string, User> => state.usersInfo.data;
